
import { DollarSign, Shield } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Investment } from "@/types/investment";
import { formatCurrency } from "./utils";

interface InvestmentSummaryCardProps {
  investment: Investment;
}

const InvestmentSummaryCard = ({ investment }: InvestmentSummaryCardProps) => {
  return (
    <Card className="mt-8">
      <CardHeader>
        <CardTitle className="flex items-center text-yellow-800">
          <DollarSign className="h-5 w-5 mr-2" />
          Investment Opportunity Summary
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <h4 className="font-semibold mb-2">Investment Details</h4>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span>Asking Price:</span>
                <span className="font-semibold">
                  {investment.askingPrice ? formatCurrency(investment.askingPrice) : 'Contact for Price'}
                </span>
              </div>
              <div className="flex justify-between">
                <span>Minimum Bid:</span>
                <span className="font-semibold">{formatCurrency(investment.minimumBid)}</span>
              </div>
              <div className="flex justify-between">
                <span>Expected Annual Return:</span>
                <span className="font-semibold text-green-600">{investment.yield}%</span>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-2">Risk Assessment</h4>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span>Risk Level:</span>
                <Badge variant="secondary">{investment.riskLevel}</Badge>
              </div>
              <div className="flex justify-between">
                <span>Investment-to-Value:</span>
                <span className="font-semibold">{investment.ltv}%</span>
              </div>
              <div className="flex justify-between">
                <span>Security:</span>
                <span className="text-green-600 font-semibold flex items-center">
                  <Shield className="h-4 w-4 mr-1" />
                  Property Secured
                </span>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default InvestmentSummaryCard;
